export default __webpack_public_path__ + "static/logo-imecc-513x450-6dc7db99dedec04948a37ca046d3a581.png";